export enum ZatcaMode {
    Developer = 0,
    Simulation = 1,
    Production = 2,
}

export const ZatcaModeTranslations: Record<ZatcaMode, string> = {
    [ZatcaMode.Developer]: 'وضع المطور',
    [ZatcaMode.Simulation]: 'محاكاة',
    [ZatcaMode.Production]: 'تشغيلي',
};

